import { AWSAmplifyConfig } from "tripkit-react/dist/account/TKAWSCognitoAccountProvider";

export interface EnvironmentConfig {
    amplifyConfig: AWSAmplifyConfig;
    tNCs_page_URL: string;
    recover_ABT_account: string;
    open_portal: string
    journey_planner_web_URL: string;
    dA_TC_web_callback: string;
    app_store_url?: string;
    play_store_url?: string;
}

const config1A: EnvironmentConfig = {
    amplifyConfig: {
        Auth: {
            Cognito: {
                userPoolId: 'ap-south-1_kPXxo80Hn',
                userPoolClientId: '13l8al35deamf0j4cqh7hr7mmr',
                signUpVerificationMethod: 'code', // 'code' | 'link'
                loginWith: {
                    // OPTIONAL - Hosted UI configuration
                    oauth: {
                        domain: "auth.abtcustomer.com",
                        scopes: [
                            'email',
                            'openid',
                            'aws.cognito.signin.user.admin'
                        ],
                        redirectSignIn: [window.location.origin + '/'],
                        redirectSignOut: [window.location.origin + '/'],
                        responseType: 'code', // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code                    
                        providers: [{
                            custom: "abt-act-da"
                        }]
                    }
                }
            }
        }
    },
    tNCs_page_URL: "https://actgov--mywaytst.sandbox.my.site.com/daidp/s/mywaytnc",
    recover_ABT_account: "https://customers-dev.abtcustomer.com/login",
    open_portal: "https://customers-dev.abtcustomer.com/core/mycards",
    journey_planner_web_URL: "https://myway.tripgo.com",
    dA_TC_web_callback: "https://myway.tripgo.com",
    app_store_url: "https://apps.apple.com/us/app/",
    play_store_url: "https://play.google.com/store/apps/"
};

const config2: EnvironmentConfig = {
    amplifyConfig: {
        Auth: {
            Cognito: {
                userPoolId: 'ap-southeast-2_N97JwzkvM',
                userPoolClientId: '4c0gv07khjrhguob1tfi4r28m3',
                signUpVerificationMethod: 'code', // 'code' | 'link'
                loginWith: {
                    // OPTIONAL - Hosted UI configuration
                    oauth: {
                        domain: "abt-dev.auth.ap-southeast-2.amazoncognito.com",
                        scopes: [
                            'email',
                            'openid',
                            'aws.cognito.signin.user.admin'
                        ],
                        redirectSignIn: [window.location.origin + '/'],
                        redirectSignOut: [window.location.origin + '/'],
                        responseType: 'code', // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code                    
                        providers: [{
                            custom: "abt-act-da"
                        }]
                    }
                }
            }
        }
    },
    tNCs_page_URL: "https://actgov--sit.sandbox.my.site.com/daidp/s/mywaytnc",
    recover_ABT_account: "https://customer.dev.abt-non-prod.nec.com.au/login",
    open_portal: "https://customer.dev.abt-non-prod.nec.com.au/core/mycards",
    journey_planner_web_URL: "https://myway.tripgo.com",
    dA_TC_web_callback: "https://myway.tripgo.com",
    app_store_url: "https://apps.apple.com/us/app/",
    play_store_url: "https://play.google.com/store/apps/"
};

const config3A: EnvironmentConfig = {
    amplifyConfig: {
        Auth: {
            Cognito: {
                userPoolId: 'ap-southeast-2_0D6IIgr8m',
                userPoolClientId: '220b9s2an8gl1hpnu29q0aeg53',
                signUpVerificationMethod: 'code', // 'code' | 'link'
                loginWith: {
                    // OPTIONAL - Hosted UI configuration
                    oauth: {
                        domain: "tc-prod.auth.ap-southeast-2.amazoncognito.com",
                        scopes: [
                            'email',
                            'openid',
                            'aws.cognito.signin.user.admin'
                        ],
                        redirectSignIn: [window.location.origin + '/'],
                        redirectSignOut: [window.location.origin + '/'],
                        responseType: 'code', // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code                    
                        providers: [{
                            custom: "abt-act-da"
                        }]
                    }
                }
            }
        }
    },
    tNCs_page_URL: "https://actgov--staging.sandbox.my.site.com/daidp/s/mywaytnc",
    recover_ABT_account: "https://ticketing.transportcanberra.nec.com.au/login",
    open_portal: "https://ticketing.transportcanberra.nec.com.au/core/mycards",
    journey_planner_web_URL: "https://myway.tripgo.com",
    dA_TC_web_callback: "https://myway.tripgo.com",
    app_store_url: "https://apps.apple.com/us/app/",
    play_store_url: "https://play.google.com/store/apps/"
};

const config4: EnvironmentConfig = {
    amplifyConfig: {
        Auth: {
            Cognito: {
                userPoolId: 'ap-southeast-2_0D6IIgr8m', // **done**
                userPoolClientId: '220b9s2an8gl1hpnu29q0aeg53', // **done**
                signUpVerificationMethod: 'code', // 'code' | 'link'
                loginWith: {
                    // OPTIONAL - Hosted UI configuration
                    oauth: {
                        domain: "tc-prod.auth.ap-southeast-2.amazoncognito.com",    // **done**
                        scopes: [
                            'email',
                            'openid',
                            'aws.cognito.signin.user.admin'
                        ],
                        redirectSignIn: [window.location.origin + '/'],
                        redirectSignOut: [window.location.origin + '/'],
                        responseType: 'code', // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code                    
                        providers: [{
                            custom: "abt-act-da"
                        }]
                    }
                }
            }
        }
    },
    tNCs_page_URL: "https://www.myaccount.act.gov.au/daidp/s/mywaytnc",  // **done**
    recover_ABT_account: "https://mywayplus.transport.act.gov.au/login",    // **done** --> not in https://redmine.buzzhives.com/issues/22685
    open_portal: "https://mywayplus.transport.act.gov.au/core/mycards", // **done** --> not in https://redmine.buzzhives.com/issues/22685
    journey_planner_web_URL: "https://myway.tripgo.com",
    dA_TC_web_callback: "https://myway.tripgo.com",
    app_store_url: "https://apps.apple.com/us/app/",
    play_store_url: "https://play.google.com/store/apps/"
};

const configMFA: EnvironmentConfig = {
    amplifyConfig: {
        Auth: {
            Cognito: {
                userPoolId: 'ap-southeast-2_iZ8lBQxLJ',
                userPoolClientId: '411up5g9m1lq6leull5mpp76vr',
                signUpVerificationMethod: 'code', // 'code' | 'link'
                loginWith: {
                    // OPTIONAL - Hosted UI configuration
                    oauth: {
                        domain: "tc-dev.auth.ap-southeast-2.amazoncognito.com",
                        scopes: [
                            'email',
                            'openid',
                            'aws.cognito.signin.user.admin'
                        ],
                        redirectSignIn: ['mywayplus://'],
                        redirectSignOut: ['mywayplus://'],
                        responseType: 'code', // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code                    
                        providers: [{
                            custom: "abt-act-da"
                        }]
                    },
                    email: true, // Enable email as username attribute
                },
                // MFA Configuration
                mfa: {
                    status: 'optional', // 'on' | 'off' | 'optional'
                    smsEnabled: true,
                    totpEnabled: false
                },
                // Password protection settings
                passwordFormat: {
                    minLength: 10,
                    requireLowercase: true,
                    requireUppercase: true,
                    requireNumbers: true,
                    requireSpecialCharacters: true
                },
                // User attributes for sign up
                userAttributes: {
                    email: {
                        required: true
                    },
                    phone_number: {
                        required: false
                    }
                }
            }
        }
    },
    tNCs_page_URL: "https://www.myaccount.act.gov.au/daidp/s/mywaytnc",
    recover_ABT_account: "https://mywayplus.transport.act.gov.au/login",
    open_portal: "https://mywayplus.transport.act.gov.au/core/mycards",
    journey_planner_web_URL: "https://myway.tripgo.com",
    dA_TC_web_callback: "https://myway.tripgo.com",
    app_store_url: "https://apps.apple.com/us/app/",
    play_store_url: "https://play.google.com/store/apps/"
}

export function getEnvironmentConfig() {
    // return config1A;
    // return config2;
    // return config3A;
    // return config4;
    return configMFA;
}


// const awsAmplifyTripGoConfig: AWSAmplifyConfig = {
//     Auth: {
//         Cognito: {
//             //  Amazon Cognito User Pool ID
//             userPoolId: 'ap-southeast-2_wMEJQ4SXg',
//             // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
//             userPoolClientId: '762pe9jpmdaqkvdou4rttm7odp',
//             // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
//             // identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
//             // OPTIONAL - Set to true to use your identity pool's unauthenticated role when user is not logged in
//             // allowGuestAccess: true,
//             // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
//             // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
//             signUpVerificationMethod: 'code', // 'code' | 'link'
//             loginWith: {
//                 // OPTIONAL - Hosted UI configuration
//                 oauth: {
//                     domain: 'necbeta430643db-430643db-dev.auth.ap-southeast-2.amazoncognito.com',
//                     scopes: [
//                         'phone',
//                         'email',
//                         'profile',
//                         'openid',
//                         'aws.cognito.signin.user.admin'
//                     ],
//                     redirectSignIn: ['http://localhost:3000/'],
//                     redirectSignOut: ['http://localhost:3000/'],
//                     // responseType: 'token' // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code
//                     responseType: 'code' // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code
//                 }
//             }
//         }
//     }
// };